<template>
  <div id="greyscreen">
    <ManageLTI v-if="greyscreen.view === 'lti'"></ManageLTI>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapGetters, mapActions, mapMutations } from 'vuex';
  import ManageLTI from './modal-views/ManageLTI';
  export default {
    name: 'Greyscreen',
    components: {
      ManageLTI
    },
    data() {
      return { }
    },
    props: [ ],
    computed: {
      ...mapGetters([
        'greyscreen',
      ]),
    },
  }
    
</script>

<style>
  #greyscreen {
    width:100vw;
    height: 100vh;
    z-index: 1000;
    position: absolute;
    background-color: #383838; /*color in strayer mockup*/
    /*background-color: #757575;*/ /*original greyscreen color*/
    overflow-y: scroll;
  }
  
  #greyscreen h1,
  #greyscreen h2,
  #greyscreen h3,
  #greyscreen div,
  #greyscreen p,
  #greyscreen strong {
    color: #fff;
  }

  
</style>